import { useFormik } from "formik";

export function useFormikWrapper(params = {}) {
  const formik = useFormik({ ...params });
  const validationSchema = params.validationSchema;
  const isFieldRequired = (name) => {
    return validationSchema?.describe()?.fields
      ? !validationSchema?.fields[name]?.spec?.optional
      : false;
  };
  return { ...formik, isFieldRequired, validationSchema };
}
